// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.start-button {
    background-color: darkseagreen;
    color: #000;
    padding: 0.5rem 1rem;
    border: none;
    cursor: pointer;
    font-size: 1.2rem;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.start-button:hover {
    background-color: #e2e6ea;
}

.start-button:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.5);
}

.send-button {
    margin-top: 40px;
    background-color: darkseagreen;
    color: #000;
    padding: 0.5rem 1rem;
    border: none;
    cursor: pointer;
    font-size: 1.2rem;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.send-button:hover {
    background-color: #e2e6ea;
}

.send-button:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.5);
}

.custom-select {
    width: 30%; /* Set the width to 30% of the parent container */
    padding: 0.5rem;
    font-size: 1rem;
    border-radius: 4px;
    border: 1px solid #ccc;
}

.quiz-description {
    font-size: 1rem;
    line-height: 1.6;
    color: #333;
    margin-bottom: 2rem;
}

.quiz-question-h1 {
    font-size: 3.5rem;
    font-weight: 300;
    line-height: 1.2;
    padding-bottom: 40px;
}

/* Media query for screens smaller than 768px (typical mobile devices) */
@media (max-width: 767px) {
    .quiz-question-h1 {
        font-size: 1.5rem;
    }
}

.quiz-list-element {
    position: relative;
    display: block;
    padding: 0.75rem 1.25rem;
    margin-bottom: 0;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.125);
    justify-content: space-between;
}

.quiz-list-element:hover {
    cursor: pointer;
    background-color: lightgrey;
}

.quiz-list-element:focus {
    background-color: lightskyblue;
}

.quiz-list-element-selected {
    background-color: lightskyblue;
}
.quiz-list-element-selected:hover {
    background-color: lightskyblue;
}

.main-modal-content {
    margin-top: 20px;
    margin-bottom: 20px;
    height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/Tests.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,WAAW;IACX,oBAAoB;IACpB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,4CAA4C;AAChD;;AAEA;IACI,gBAAgB;IAChB,8BAA8B;IAC9B,WAAW;IACX,oBAAoB;IACpB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,4CAA4C;AAChD;;AAEA;IACI,UAAU,EAAE,iDAAiD;IAC7D,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA,wEAAwE;AACxE;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,wBAAwB;IACxB,gBAAgB;IAChB,sBAAsB;IACtB,sCAAsC;IACtC,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;AACA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;AAChB","sourcesContent":[".start-button {\n    background-color: darkseagreen;\n    color: #000;\n    padding: 0.5rem 1rem;\n    border: none;\n    cursor: pointer;\n    font-size: 1.2rem;\n    border-radius: 4px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.start-button:hover {\n    background-color: #e2e6ea;\n}\n\n.start-button:focus {\n    outline: none;\n    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.5);\n}\n\n.send-button {\n    margin-top: 40px;\n    background-color: darkseagreen;\n    color: #000;\n    padding: 0.5rem 1rem;\n    border: none;\n    cursor: pointer;\n    font-size: 1.2rem;\n    border-radius: 4px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.send-button:hover {\n    background-color: #e2e6ea;\n}\n\n.send-button:focus {\n    outline: none;\n    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.5);\n}\n\n.custom-select {\n    width: 30%; /* Set the width to 30% of the parent container */\n    padding: 0.5rem;\n    font-size: 1rem;\n    border-radius: 4px;\n    border: 1px solid #ccc;\n}\n\n.quiz-description {\n    font-size: 1rem;\n    line-height: 1.6;\n    color: #333;\n    margin-bottom: 2rem;\n}\n\n.quiz-question-h1 {\n    font-size: 3.5rem;\n    font-weight: 300;\n    line-height: 1.2;\n    padding-bottom: 40px;\n}\n\n/* Media query for screens smaller than 768px (typical mobile devices) */\n@media (max-width: 767px) {\n    .quiz-question-h1 {\n        font-size: 1.5rem;\n    }\n}\n\n.quiz-list-element {\n    position: relative;\n    display: block;\n    padding: 0.75rem 1.25rem;\n    margin-bottom: 0;\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.125);\n    justify-content: space-between;\n}\n\n.quiz-list-element:hover {\n    cursor: pointer;\n    background-color: lightgrey;\n}\n\n.quiz-list-element:focus {\n    background-color: lightskyblue;\n}\n\n.quiz-list-element-selected {\n    background-color: lightskyblue;\n}\n.quiz-list-element-selected:hover {\n    background-color: lightskyblue;\n}\n\n.main-modal-content {\n    margin-top: 20px;\n    margin-bottom: 20px;\n    height: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
